<template>
  <div>
    <v-container
      v-for="(item, index) in transactions"
      :key="index"
      grid-list-md
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs8
          text-xs-left
        >
          <div>
            <span>XXX-WPGART:</span>
            <b class="ml-1">{{ item['XXX-WPGART'] }}</b>
          </div>
          <div>
            <span>XXX-NW:</span>
            <b class="ml-1">{{ item['XXX-NW'] }}</b>
          </div>
          <div>
            <span>XXX-BOKZBEZ:</span>
            <b class="ml-1">{{ item['XXX-BOKZBEZ'] }}</b>
          </div>
        </v-flex>
        <v-flex
          xs4
          text-xs-center
        >
          <v-chip
            label
            color="blue darken-3"
            text-color="white"
          >
            <span>XXX-BUDAT:</span>
            <b class="ml-1">{{ item['XXX-BUDAT'] }}</b>
          </v-chip>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'SecurityTransactions',
  props: {
    transactions: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>
<style lang="scss" scoped>
.grid-list-md {
  background-color: #fff;
  margin-bottom: 1px;
}
.grid-list-md:last-child {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/baader/SecurityTransactions.vue